export default class ObjectError extends Error {
  constructor (message, errors) {
    super(message)
    this.errors = errors
  }
}
